import { render, staticRenderFns } from "./BlogsCarouselSection.vue?vue&type=template&id=1a72e54c&scoped=true&"
import script from "./BlogsCarouselSection.vue?vue&type=script&lang=js&"
export * from "./BlogsCarouselSection.vue?vue&type=script&lang=js&"
import style0 from "./BlogsCarouselSection.vue?vue&type=style&index=0&id=1a72e54c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72e54c",
  null
  
)

export default component.exports